module.exports = __webpack_public_path__ + "img/rwandagroup.96bee75e.jpeg";